import React from 'react';
import { ToastContainer } from 'containers/Toast/ToastContainer';
import { PrivateRoutes } from 'components/Router/Router';
import { LIVE_MEETING_INACTIVITY_TIMEOUT } from 'constants/liveMeetings';
import IdleTimer from 'react-idle-timer';

interface Props {
  handleCalendarMessage: () => void;
  setActive: (active: boolean) => void;
  permissionsObject: object;
  online: () => void;
  offline: () => void;
}

class App extends React.Component<Props, object> {
  componentWillMount() {
    window.addEventListener('offline', this.handleOffline);
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('message', this.props.handleCalendarMessage, false);
  }

  componentWillUnmount() {
    window.removeEventListener('offline', this.handleOffline);
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('message', this.props.handleCalendarMessage);
  }

  handleOnline = () => {
    this.props.online();
  }

  handleOffline = () => {
    this.props.offline();
  }

  render() {
    const { permissionsObject, setActive } = this.props;
    return (
      <>
        {PrivateRoutes({ permissionsObject })}
        <IdleTimer
          element={document}
          onActive={() => setActive(true)}
          onIdle={() => setActive(false)}
          debounce={250}
          timeout={LIVE_MEETING_INACTIVITY_TIMEOUT}
        />
        <ToastContainer />
      </>
    );
  }
}

export { App };
